import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from '../../service/login.service';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
  imports: [RouterLink, MatButtonModule, NgClass, RouterLinkActive],
})
export class NavMenuComponent implements OnInit {
  router = inject(Router);
  loginService = inject(LoginService);

  collapse: string = 'collapse';
  showCollapseNav: boolean = false;

  ngOnInit() {
    this.showCollapseNav = false;
  }

  collapseNavbar(): void {
    if (this.collapse.length > 1) {
      this.collapse = '';
    } else {
      this.collapse = 'collapse';
    }
  }

  logout() {
    this.loginService.logout();
  }

  hideMenu(): boolean {
    this.showCollapseNav = false;
    return true;
  }
}
